import { render, staticRenderFns } from "./OrderMappings.vue?vue&type=template&id=4c60fe6d&scoped=true"
import script from "./OrderMappings.vue?vue&type=script&lang=js"
export * from "./OrderMappings.vue?vue&type=script&lang=js"
import style0 from "./OrderMappings.vue?vue&type=style&index=0&id=4c60fe6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60fe6d",
  null
  
)

export default component.exports